import { Component, OnInit } from '@angular/core';

import { DialogRef } from '@ngneat/dialog';
import { TranslateService } from '@ngx-translate/core';
import { InfoSection } from 'rest-client';
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from 'swiper/core';

import { environment } from '@env/environment';
import { InfoSectionDialogData } from '@shared/models';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const TAGS = 'tags';
const OPERATIONS = 'operations';
const PARTS = 'parts';
const PRICE = 'price';
const PRICE_DETAIL = 'priceDetail';
const SWIPER_CONFIG = {
  spaceBetween: 10,
  slidesPerView: 1.5,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  observer: true,
  observeParents: true,
};

@Component({
  selector: 'bkg-info-section-dialog',
  templateUrl: './info-section-dialog.component.html',
  styleUrls: ['./info-section-dialog.component.scss'],
})
export class InfoSectionDialogComponent implements OnInit {
  data = this.ref.data as InfoSectionDialogData;
  subDetailsCollapse = false;
  swiperConfig = SWIPER_CONFIG;
  initialSlide = 0;
  isProcessing = false;

  constructor(
    public ref: DialogRef,
    private translateService: TranslateService
  ) { }

  get imageGalleryIsVisible(): boolean {
    return !!this.data.imageGallery?.length;
  }

  get subDetailIsVisible(): boolean {
    return !!this.data.estimateOperations?.subdetail_control?.length;
  }

  get isRemove(): boolean {
    return (
      (this.translateService.instant(
        this.data?.confirmTextTranslationKey
      ) as string) ===
      (this.translateService.instant(
        'sharedModule.bkgInfoSectionDialog.removeFromMyBooking'
      ) as string)
    );
  }

  ngOnInit(): void {
    if (this.imageGalleryIsVisible && this.data.imageGallery.length > 1) {
      this.initialSlide = Math.ceil(this.data.imageGallery.length / 2) - 1;
    }

  }

  get hasPrice(): boolean {
    return !!this.data.infoSections.some(
      (section: InfoSection) => section.type === 'price'
    );
  }

  getImgUrl(url: string): string {
    return environment.PUBLIC_URL + url;
  }

  isDefault(infoSection: InfoSection): boolean {
    return (
      infoSection.type !== TAGS &&
      infoSection.type !== OPERATIONS &&
      infoSection.type !== PRICE
    );
  }

  isTags(infoSection: InfoSection): boolean {
    return infoSection.type === TAGS;
  }

  isOperations(infoSection: InfoSection): boolean {
    return infoSection.type === OPERATIONS;
  }

  isParts(infoSection: InfoSection): boolean {
    return infoSection.type === PARTS;
  }

  isPrice(infoSection: InfoSection): boolean {
    return infoSection.type === PRICE;
  }

  isPriceDetail(infoSection: InfoSection): boolean {
    return infoSection.type === PRICE_DETAIL;
  }

  onClickClose(): void {
    this.ref.close(false);
  }

  onClickSelect(): void {
    this.isProcessing = true;
    this.ref.close(true);
  }

  onExpandCollapseSubOperations(): void {
    this.subDetailsCollapse = !this.subDetailsCollapse;
  }


}
